import React, { useEffect, useState } from "react";
import {
  Collapse,
  InputNumber,
  Button,
  Space,
  Typography,
  message,
  List,
  Checkbox,
  Card,
  DatePicker,
  Row,
  Col,
  Input,
  Select,
} from "antd";
import axios from "axios";

/* DELETE     import record_selected from "../img/record_selected_64.png";
import authoring_selected from "../img/authoring_selected_64.png";
import read_aloud_selected from "../img/read_aloud_selected_64.png";
import word_clarification_selected from "../img/word_clarification_selected_64.png";
import word_wall_selected from "../img/word_wall_selected_64.png";*/

import { taskRegistry } from "../config/taskRegistry";
import { reflectionForms } from "../config/reflectionForms";

const { Panel } = Collapse;
const { Text } = Typography;
const { TextArea } = Input;

const Activity = ({
  activities = [],
  classId,
  onGroupsGenerated,
  selectedGroupMembers = [],
  selectedGroupActivityId = null,
  selectedGroupId = null,
  selectedGroupName = "",
  activeActivityId = null,
  StoryOptionLabel,
}) => {
  const [groupCounts, setGroupCounts] = useState({});
  const [loadingIds, setLoadingIds] = useState({});
  const [taskLoadingIds, setTaskLoadingIds] = useState({});
  const [deletingIds, setDeletingIds] = useState({});
  const [activeActivity, setActiveActivity] = useState(null);

  const [characters, setCharacters] = useState([]);
  const [members, setMembers] = useState([]);

  const [existingTasks, setExistingTasks] = useState([]);

  const [selectedStory, setSelectedStory] = useState(null);
  const [taskDescription, setTaskDescription] = useState("");
  const [selectedCharacters, setSelectedCharacters] = useState([]);
  const [taskType, setTaskType] = useState(null);
  const [assignedMember, setAssignedMember] = useState(null);
  const [useCharacterCount, setUseCharacterCount] = useState(false);
  const [characterCount, setCharacterCount] = useState(1);
  const [selectedTaskTypes, setSelectedTaskTypes] = useState([]);

  const [selectedReflectionTypes, setSelectedReflectionTypes] = useState([]);

  const [reflectionTasks, setReflectionTasks] = useState([]);

  const [selectedDescriptions, setSelectedDescriptions] = useState({});

  const [groupTasks, setGroupTasks] = useState([]);
  const [groupTasksLoading, setGroupTasksLoading] = useState(false);
  const [movingMemberIds, setMovingMemberIds] = useState({});
  const [localGroupMembers, setLocalGroupMembers] = useState([]);

  useEffect(() => {
    setLocalGroupMembers(selectedGroupMembers || []);
  }, [selectedGroupMembers, selectedGroupId]);

  const fetchGroupTasks = async (groupId) => {
    if (!groupId) {
      setGroupTasks([]);
      setGroupTasksLoading(false);
      return;
    }
    setGroupTasksLoading(true);
    try {
      const res = await axios.get(`/api/tasks/groups/${groupId}/tasks-with-users`);
      setGroupTasks(Array.isArray(res.data) ? res.data : []);
    } catch (error) {
      setGroupTasks([]);
    } finally {
      setGroupTasksLoading(false);
    }
  };

  const handleMoveMemberToGroup = async (memberId, targetGroupId) => {
    if (!selectedGroupId || !memberId || !targetGroupId) return;

    try {
      setMovingMemberIds((prev) => ({ ...prev, [memberId]: true }));
      await axios.put(`/api/groups/${selectedGroupId}/members`, {
        userId: memberId,
        targetGroupId,
      });
      setLocalGroupMembers((prev) => prev.filter((m) => Number(m.id) !== Number(memberId)));
      message.success("Mitglied wurde verschoben.");
      if (onGroupsGenerated) {
        onGroupsGenerated();
      }
    } catch (error) {
      if (error.response?.status === 400 || error.response?.status === 403) {
        message.error(error.response?.data || "Verschieben nicht möglich.");
      } else {
        message.error("Fehler beim Verschieben des Mitglieds.");
      }
    } finally {
      setMovingMemberIds((prev) => ({ ...prev, [memberId]: false }));
    }
  };

  useEffect(() => {
	console.log("Selected Group ID changed:", selectedGroupId);
    fetchGroupTasks(selectedGroupId);
  }, [selectedGroupId]);

  useEffect(() => {
    const nextActive =
      activities.find((act) => act.id === activeActivityId) || null;
    setActiveActivity(nextActive);
    console.log("Selected Group Activity ID:", selectedGroupActivityId);
    console.log("Selected activeActivityId:", activeActivityId);
    console.log("Selected Group Name:", selectedGroupName);
    console.log("Selected Activity:", nextActive);
  }, [
    activeActivityId,
    activities,
    selectedGroupActivityId,
    selectedGroupName,
  ]);
  useEffect(() => {
    if (!activeActivity) {
      setCharacters([]);
      return;
    }
    fetchStoryData()
      .then((charResponse) => {
        if (charResponse) {
          setCharacters(charResponse.data);
        }
      })
      .catch(() => {
        setCharacters([]);
      });
  }, [activeActivity]);
  useEffect(() => {
    console.log("Story characters: ", characters);
  }, [characters]);

  const taskTypeIconStyle = {
    width: 20,
    height: 20,
    objectFit: "contain",
  };

  /*DELETE  const taskTypes = [
		{ value: "record", label: "Aufnehmen", imgSrc: record_selected },
		{ value: "feedback", label: "Feedback geben", fallbackIcon: <span style={{ fontSize: 18, lineHeight: 1 }}>✏</span> },
		{ value: "analyze", label: "Wortwolke", imgSrc: word_wall_selected },
		{ value: "enrichments", label: "Gestalten", imgSrc: authoring_selected },
		{ value: "hexiLexi", label: "HexiLexi", imgSrc: word_clarification_selected },
		{ value: "vorlesen", label: "Vorlesen", imgSrc: read_aloud_selected },
	];*/

  const taskTypes = Object.entries(taskRegistry).map(([key, value]) => ({
    value: key,
    label: value.label,
    imgSrc: value.icon,
    fallbackIcon: value.iconFallback,
  }));

  const reflectionOptions = Object.entries(reflectionForms).map(
    ([key, form]) => ({
      value: key,
      label: form.label,
    })
  );

  const addReflectionTask = () => {
    setReflectionTasks((prev) => [
      ...prev,
      {
        type: null,
        deadline: null,
        priority: 1,
      },
    ]);
  };

  const updateReflectionTask = (index, key, value) => {
    const updated = [...reflectionTasks];
    updated[index][key] = value;
    setReflectionTasks(updated);
  };

  const handleTaskTypeChange = (taskValue) => {
    setSelectedTaskTypes((prev) =>
      prev.some((task) => task.value === taskValue)
        ? prev.filter((task) => task.value !== taskValue)
        : [...prev, { value: taskValue, deadline: null, priority: "MED" }]
    );
  };

  const handleTaskTypeDeadlineChange = (taskValue, deadline) => {
    setSelectedTaskTypes((prev) =>
      prev.map((task) =>
        task.value === taskValue ? { ...task, deadline } : task
      )
    );
  };

  const handleTaskTypePriorityChange = (taskValue, priority) => {
    setSelectedTaskTypes((prev) =>
      prev.map((task) =>
        task.value === taskValue ? { ...task, priority } : task
      )
    );
  };

  const handleDescriptionChange = (taskKey, descriptionId) => {
    setSelectedDescriptions((prev) => ({
      ...prev,
      [taskKey]: descriptionId,
    }));

    console.log("setSelectedDescriptions: ", selectedDescriptions);
  };

  const handleReflectionTypeChange = (value) => {
    setSelectedReflectionTypes((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
    );
  };

  const fetchStoryData = async () => {
    // setMembers([]); // Reset members when a new story is selected
    // setExistingTasks([]); // Reset existing tasks
    // setSelectedCharacters(
    // ALL_CHARACTERS_TASK_TYPES.has(taskType) ? ["alles"] : []
    // ); // Reset selected characters when a new story is selected

    try {
      const charResponse = await axios.get(
        `/api/characters/?storycharid=${activeActivity.story_id}`
      );
      //   console.log("charResponse:", charResponse);
      return charResponse;
      //   activeActivity.groups.forEach(async grp => {
      // 	const membersResponse = await axios.get(`/api/groups/${grp.id}/members`);
      // 	console.log("membersResponse:", membersResponse);
      // 	setMembers(membersResponse.data);
      //   });

      // Fetch existing tasks for this story within the current group
      //   const tasksResponse = await axios.get(`/api/tasks/${id}/${storyId}`);
      //   console.log("tasksResponse:", tasksResponse);
      //   setExistingTasks(tasksResponse.data); // Store tasks so we can filter characters
    } catch (error) {
      message.error("Fehler beim Laden der Daten.");
      console.error("Error fetching characters or members:", error);
    }
  };
  const handleGroupCountChange = (activityId, value) => {
    setGroupCounts((prev) => ({
      ...prev,
      [activityId]: value,
    }));
  };

  const handleGenerateGroups = async (activityId) => {
    const groupCount = useCharacterCount ? null : groupCounts[activityId];

    if (!classId) {
      message.error("Klasse nicht gefunden.");
      return;
    }

    if (!useCharacterCount && (!groupCount || groupCount <= 0)) {
      message.error("Bitte gib eine gültige Gruppenzahl ein.");
      return;
    }

    if (useCharacterCount && (!characterCount || characterCount <= 0)) {
      message.error("Bitte gib eine gültige Charakteranzahl ein.");
      return;
    }

    try {
      setLoadingIds((prev) => ({ ...prev, [activityId]: true }));
      await axios.post(`/api/classes/${classId}/gen-g`, {
        act_id: activityId,
        groupCount,
        useCharacterCount,
        characterCount: useCharacterCount ? characters.length : null,
      });
      message.success("Gruppen wurden erstellt.");
      if (onGroupsGenerated) {
        onGroupsGenerated();
      }
    } catch (error) {
      console.error("Error generating groups:", error);
      if (error.response?.status === 400) {
        message.error(error.response.data || "Ungültige Eingabe.");
      } else {
        message.error("Fehler beim Erstellen der Gruppen.");
      }
    } finally {
      setLoadingIds((prev) => ({ ...prev, [activityId]: false }));
    }
  };

  const handleGenerateTasks = async (activityId) => {
    if (!classId) {
      message.error("Klasse nicht gefunden.");
      return;
    }

    if (!activeActivity?.story_id) {
      message.error("Keine Geschichte mit dieser Aktivität verknüpft.");
      return;
    }

    if (!selectedTaskTypes.length) {
      message.error("Bitte wähle mindestens einen Aufgabentyp aus.");
      return;
    }

    const finalTasks = buildTaskSequence().map((t) => ({
      value: t.type,
      reflectionType: t.subType || null,
      seq_no: t.seqNum,
      deadline: t.deadline ? t.deadline.format("YYYY-MM-DD HH:mm:ss") : null,
      priority: t.priority ?? 1,
    }));

    console.log("Final tasks to send:", finalTasks);

    try {
      setTaskLoadingIds((prev) => ({ ...prev, [activityId]: true }));
      await axios.post(`/api/classes/${classId}/gen-t`, {
        act_id: activityId,
        story_id: activeActivity.story_id,
        selectedTaskTypes: finalTasks,
        characters: characters || null,
        selectedDescriptions,
      });
      await fetchGroupTasks(selectedGroupId);
      message.success("Aufgaben wurden erstellt.");
      if (onGroupsGenerated) {
        onGroupsGenerated();
      }
    } catch (error) {
      console.error("Error generating tasks:", error);
      if (error.response?.status === 400) {
        message.error(error.response.data || "Ungültige Eingabe.");
      } else {
        message.error("Fehler beim Erstellen der Aufgaben.");
      }
    } finally {
      setTaskLoadingIds((prev) => ({ ...prev, [activityId]: false }));
    }
  };

  const handleDeleteTasks = async (activityId) => {
    try {
      // setDeletingTaskIds((prev) => ({ ...prev, [activityId]: true }));
      await axios.delete(`/api/tasks/all/${activityId}`);
      message.success("Aufgaben wurde gelöscht.");
      if (onGroupsGenerated) {
        onGroupsGenerated();
      }
      fetchGroupTasks(selectedGroupId);
    } catch (error) {
      console.error("Error deleting aufgaben:", error);
      message.error("Fehler beim Löschen der aufgaben.");
    } finally {
      // setDeletingIds((prev) => ({ ...prev, [activityId]: false }));
    }
  };

  const handleDeleteActivity = async (activityId) => {
    try {
      setDeletingIds((prev) => ({ ...prev, [activityId]: true }));
      await axios.delete(`/api/activities/${activityId}`);
      message.success("Aktivität wurde gelöscht.");
      if (onGroupsGenerated) {
        onGroupsGenerated();
      }
    } catch (error) {
      console.error("Error deleting activity:", error);
      message.error("Fehler beim Löschen der Aktivität.");
    } finally {
      setDeletingIds((prev) => ({ ...prev, [activityId]: false }));
    }
  };

  if (!activities || activities.length === 0) {
    return <Text type="secondary">Keine Aktivitäten vorhanden.</Text>;
  }

  const collapseActiveKey = activeActivityId
    ? String(activeActivityId)
    : undefined;

  const buildTaskSequence = () => {
    const result = [];
    let seq = 1;

    selectedTaskTypes.forEach((task) => {
      if (task.value === "nachdenken") {
        reflectionTasks.forEach((sub) => {
          result.push({
            type: "nachdenken",
            subType: sub.type,
            seqNum: seq++,
            priority: sub.priority,
            deadline: sub.deadline,
          });
        });
      } else {
        result.push({
          type: task.value,
          seqNum: seq++,
          priority: task.priority,
          deadline: task.deadline,
        });
      }
    });

    return result;
  };

  const taskSequence = buildTaskSequence();

  let globalSeq = 1;
  const getNextSeq = () => globalSeq++;

  return (
    <Collapse accordion activeKey={collapseActiveKey}>
      {activities.map((activity) => (
        <Panel
          header={activity.title}
          key={String(activity.id)}
          collapsible="disabled"
          showArrow={false}
        >
          <Space direction="vertical" style={{ width: "100%" }} size="large">
            {/* GROUP SETTINGS */}
            <Space
              direction="horizontal"
              align="start"
              style={{ width: "100%" }}
              size="large"
            >
              <Space direction="vertical" style={{ flex: 1 }}>
                <Text>Gruppenanzahl festlegen:</Text>
                <Space>
                  <Checkbox
                    checked={useCharacterCount}
                    onChange={(e) => setUseCharacterCount(e.target.checked)}
                  >
                    Charakteranzahl verwenden:
                  </Checkbox>

                  {useCharacterCount && (
                    <Text type="secondary">{characters.length}</Text>
                  )}

                  {!useCharacterCount && (
                    <InputNumber
                      min={1}
                      value={groupCounts[activity.id]}
                      onChange={(value) =>
                        handleGroupCountChange(activity.id, value)
                      }
                      disabled={useCharacterCount}
                    />
                  )}

                  <Button
                    type="primary"
                    loading={!!loadingIds[activity.id]}
                    onClick={() => handleGenerateGroups(activity.id)}
                  >
                    Gruppen generieren
                  </Button>

                  <Button
                    danger
                    loading={!!deletingIds[activity.id]}
                    onClick={() => handleDeleteActivity(activity.id)}
                  >
                    Aktivität löschen
                  </Button>
                </Space>
              </Space>
            </Space>

            {/* TASK TYPES */}
            <Card title="Aufgabentypen" size="small">
              <Row gutter={8} align="middle" style={{ marginBottom: 8 }}>
                <Col flex="28px">
                  <Text type="secondary">#</Text>
                </Col>
                <Col flex="auto">
                  <Text type="secondary">Aufgabentyp</Text>
                </Col>
                <Col flex="auto">
                  <Text type="secondary">Beschreibung</Text>
                </Col>
                <Col flex="120px">
                  <Text type="secondary">Priorität</Text>
                </Col>
                <Col flex="190px">
                  <Text type="secondary">Deadline</Text>
                </Col>
              </Row>

              <Space
                direction="vertical"
                size="small"
                style={{ width: "100%" }}
              >
                {taskTypes.map((taskType) => {
                  const registry = taskRegistry[taskType.value];

                  const selectedTask = selectedTaskTypes.find(
                    (task) => task.value === taskType.value
                  );

                  const isSelected = selectedTaskTypes.some(
                    (task) => task.value === taskType.value
                  );

                  const seqItem = taskSequence.find(
                    (t) => t.type === taskType.value
                  );
                  const seqNum =
                    taskType.value === "nachdenken" ? null : seqItem?.seqNum;

                  return (
                    <React.Fragment key={taskType.value}>
                      {/* MAIN ROW */}
                      <Row gutter={8} align="middle" style={{ width: "100%" }}>
                        <Col flex="28px">
                          <span
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: 20,
                              height: 20,
                              borderRadius: "50%",
                              backgroundColor: seqNum
                                ? "#1677ff"
                                : "transparent",
                              border: seqNum ? "none" : "1px dashed #d9d9d9",
                              color: seqNum ? "#fff" : "transparent",
                              fontSize: 11,
                              fontWeight: "bold",
                            }}
                          >
                            {seqNum || ""}
                          </span>
                        </Col>

                        <Col flex="auto">
                          <Checkbox
                            checked={isSelected}
                            onChange={() =>
                              handleTaskTypeChange(taskType.value)
                            }
                          >
                            <StoryOptionLabel
                              text={taskType.label}
                              imgSrc={taskType.imgSrc}
                              iconStyle={taskTypeIconStyle}
                              fallbackIcon={taskType.fallbackIcon}
                            />
                          </Checkbox>
                        </Col>

                        {/* DESCRIPTION */}
                        <Col flex="auto">
                          {isSelected && registry.descriptions && (
                            <Select
                              style={{ width: "100%" }}
                              placeholder="Beschreibung auswählen"
                              value={selectedDescriptions[taskType.value]}
                              onChange={(value) =>
                                handleDescriptionChange(taskType.value, value)
                              }
                              options={registry.descriptions.map((d) => ({
                                value: d.id,
                                label: d.label,
                              }))}
                            />
                          )}
                        </Col>

                        {/* PRIORITY */}
                        <Col flex="120px">
                          <Select
                            placeholder="Priorität"
                            style={{ width: "100%" }}
                            disabled={
                              !isSelected || taskType.value === "nachdenken"
                            }
                            value={
                              isSelected
                                ? selectedTask?.priority ?? 0
                                : undefined
                            }
                            onChange={(value) =>
                              handleTaskTypePriorityChange(
                                taskType.value,
                                value
                              )
                            }
                            options={[
                              { value: 0, label: "LOW" },
                              { value: 1, label: "MED" },
                              { value: 2, label: "HIGH" },
                            ]}
                          />
                        </Col>

                        {/* DEADLINE */}
                        <Col flex="190px">
                          <DatePicker
                            showTime
                            format="DD.MM.YYYY HH:mm"
                            style={{ width: "100%" }}
                            disabled={
                              !isSelected || taskType.value === "nachdenken"
                            }
                            value={selectedTask?.deadline || null}
                            onChange={(value) =>
                              handleTaskTypeDeadlineChange(
                                taskType.value,
                                value
                              )
                            }
                          />
                        </Col>
                      </Row>

                      {/* 👇 SUBTASKS FOR "nachdenken" */}
                      {taskType.value === "nachdenken" && isSelected && (
                        <>
                          {reflectionTasks.map((task, index) => {
                            const seqItem = taskSequence.filter(
                              (t) => t.type === "nachdenken"
                            )[index];
                            const seqNum = seqItem?.seqNum;

                            return (
                              <Row
                                key={`nachdenken-${index}`}
                                gutter={8}
                                align="middle"
                                style={{ width: "100%", marginLeft: 28 }}
                              >
                                {/* SEQ */}
                                <Col flex="28px">
                                  <span
                                    style={{
                                      display: "inline-flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      width: 20,
                                      height: 20,
                                      borderRadius: "50%",
                                      backgroundColor: "#1677ff",
                                      color: "#fff",
                                      fontSize: 11,
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {seqNum}
                                  </span>
                                </Col>

                                {/* LABEL */}
                                <Col flex="auto">
                                  <Text>Reflexion {index + 1}</Text>
                                </Col>

                                {/* TYPE */}
                                <Col flex="auto">
                                  <Select
                                    style={{ width: "100%" }}
                                    placeholder="Reflexionsformular auswählen"
                                    value={task.type}
                                    onChange={(value) =>
                                      updateReflectionTask(index, "type", value)
                                    }
                                    options={reflectionOptions}
                                  />
                                </Col>

                                {/* PRIORITY */}
                                <Col flex="120px">
                                  <Select
                                    style={{ width: "100%" }}
                                    value={task.priority}
                                    onChange={(value) =>
                                      updateReflectionTask(
                                        index,
                                        "priority",
                                        value
                                      )
                                    }
                                    options={[
                                      { value: 0, label: "LOW" },
                                      { value: 1, label: "MED" },
                                      { value: 2, label: "HIGH" },
                                    ]}
                                  />
                                </Col>

                                {/* DEADLINE */}
                                <Col flex="190px">
                                  <DatePicker
                                    showTime
                                    format="DD.MM.YYYY HH:mm"
                                    style={{ width: "100%" }}
                                    value={task.deadline}
                                    onChange={(value) =>
                                      updateReflectionTask(
                                        index,
                                        "deadline",
                                        value
                                      )
                                    }
                                  />
                                </Col>
                              </Row>
                            );
                          })}

                          {/* ADD BUTTON */}
                          <Row style={{ marginLeft: 28 }}>
                            <Col>
                              <Button onClick={addReflectionTask}>
                                + Reflexionsformular hinzufügen
                              </Button>
                            </Col>
                          </Row>
                        </>
                      )}
                    </React.Fragment>
                  );
                })}
              </Space>

              <div style={{ marginTop: 12, display: "flex", justifyContent: "flex-end", gap:8}}>
                <Button
                  type="default"
                  loading={!!taskLoadingIds[activity.id]}
                  disabled={!activity.groups || activity.groups.length === 0}
                  onClick={() => handleGenerateTasks(activity.id)}
                >
                  Aufgaben generieren
                </Button>
                <Button
                    danger
                    // loading={!!deletingIds[activity.id]}
                    onClick={() => handleDeleteTasks(activity.id)}
                  >
                    Aufgaben löschen
                  </Button>

              </div>
            </Card>

            {/* GROUP MEMBERS */}
            {selectedGroupActivityId === activity.id && (
              <Space
                direction="vertical"
                style={{ width: "100%" }}
                size="small"
              >
                <Text strong>
                  Mitglieder {selectedGroupName ? `(${selectedGroupName})` : ""}
                </Text>
                <List
                  size="small"
                  dataSource={localGroupMembers}
                  renderItem={(member) => {
                    const memberTasks = groupTasks.filter(
                      (t) => t.member_id === member.id
                    );
                    const canSwapMember =
                      !groupTasksLoading &&
                      groupTasks.length === 0 &&
                      Array.isArray(activity.groups) &&
                      activity.groups.some((g) => Number(g.id) !== Number(selectedGroupId));

                    const targetGroupOptions = (activity.groups || [])
                      .filter((g) => Number(g.id) !== Number(selectedGroupId))
                      .map((g) => ({ value: g.id, label: g.name }));

                    return (
                      <List.Item
                        extra={
                          canSwapMember ? (
                            <Select
                              style={{ minWidth: 170 }}
                              placeholder="In Gruppe verschieben"
                              loading={!!movingMemberIds[member.id]}
                              disabled={!!movingMemberIds[member.id]}
                              value={undefined}
                              options={targetGroupOptions}
                              onChange={(targetGroupId) =>
                                handleMoveMemberToGroup(member.id, targetGroupId)
                              }
                            />
                          ) : null
                        }
                      >
                        <Space direction="vertical" size={0}>
                          <Text>{member.username}</Text>
                          {memberTasks.length > 0 && (
                            <Text type="secondary" style={{ fontSize: 11 }}>
                              {memberTasks
                                .map((t) => taskRegistry[t.category]?.label || t.category)
                                .join(" → ")}
                            </Text>
                          )}
                        </Space>
                      </List.Item>
                    );
                  }}
                  locale={{ emptyText: "Keine Mitglieder" }}
                />
              </Space>
            )}
          </Space>
        </Panel>
      ))}
    </Collapse>
  );
};

export default Activity;
